import { render, staticRenderFns } from "./SelecionarTipoLaudo.vue?vue&type=template&id=6ebd758b&scoped=true&lang=pug"
import script from "./SelecionarTipoLaudo.vue?vue&type=script&lang=js"
export * from "./SelecionarTipoLaudo.vue?vue&type=script&lang=js"
import style0 from "./SelecionarTipoLaudo.vue?vue&type=style&index=0&id=6ebd758b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebd758b",
  null
  
)

export default component.exports